var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalaysiaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 279.728,
    height: 170.952,
    viewBox: "0 0 279.728 170.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(1.137 -2.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142070",
    transform: "translate(0.794 2.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68924",
    d: "M117.617,45.174A27.914,27.914,0,0,0,89.695,73.1l-1.931,143.03c9.269-.059,14.431,0,29.853,0H339.57A27.916,27.916,0,0,0,367.492,188.2V73.1A27.915,27.915,0,0,0,339.57,45.174Z",
    transform: "translate(-89.695 -45.174)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(0 0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68928",
    d: "M93.135,45.779V57.99h138.9V45.779Z",
    transform: "translate(45.764 -21.366)",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68930",
    d: "M93.135,46.384V58.595h138.9V46.384Z",
    transform: "translate(45.764 2.451)",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68932",
    d: "M93.135,46.988V59.2h138.9V46.988Z",
    transform: "translate(45.764 26.268)",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68934",
    d: "M89.695,47.593V59.8h277.8V47.593Z",
    transform: "translate(-89.695 50.084)",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68936",
    d: "M89.695,48.2V60.409h277.8V48.2Z",
    transform: "translate(-89.695 73.901)",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73577",
    d: "M93.134,45.175V57.382H229.34c-2.887-7.63-7.683-12.2-12.813-12.208Z",
    transform: "translate(45.756 -45.174)",
    fill: "#d40000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path68940",
    d: "M117.616,45.174c-15.422,0-20.377.245-27.921,0v97.684h138.9V45.174Z",
    transform: "translate(-89.695 -45.174)",
    fill: "#025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69143",
    d: "M115.8,77.81l-2.08,13.721-2.091-13.719-7.827,11.46L107.876,76,95.852,82.933l9.423-10.189L91.434,73.77l12.91-5.091L91.43,63.6l13.841,1.014L95.84,54.431l12.03,6.919-4.08-13.265,7.837,11.454,2.08-13.721,2.091,13.72,7.827-11.46-4.069,13.268,12.024-6.929L122.157,64.6,136,63.579l-12.91,5.091L136,73.751l-13.841-1.014,9.431,10.181L119.562,76l4.08,13.265Z",
    transform: "translate(-21.367 -19.831)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72101",
    d: "M123.261,45.568a32.955,32.955,0,1,0,23.4,56.166,28.206,28.206,0,1,1,.039-46.364,32.96,32.96,0,0,0-23.435-9.8Z",
    transform: "translate(-66.032 -29.679)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73579",
    d: "M89.7,48.8c.012,4.667-.07,8.4,0,12.555l272.922-.347A27.9,27.9,0,0,0,367.24,48.8Z",
    transform: "translate(-89.673 97.733)",
    fill: "#d40000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysiaFlag);
export default __webpack_public_path__ + "static/media/malaysiaFlag.87c0e398733ee5a3525434e17807ab0d.svg";
export { ForwardRef as ReactComponent };